import Vue from "vue";
import Component from "vue-class-component";
import VideoTab from '../videoTab/videoTab.vue';
import { Prop, Watch, Inject } from 'vue-property-decorator';
import Axios from 'axios';
import Subtitles from '../subtitles/subtitles'
import { ImagePlayer } from "../../utils/imgPlayer";
import moduleStore from '../../store/videoEditor';
import ImgTrack from "../imgTrack/imgTrack";
import { bgaToColor, colorTobga } from "../../utils/utils";
import { DEFAULTFONTSIZE, RESOLUTION } from "../../utils/constant";
import { judgeDeviceType } from "@/utils/device";
import PageState from "../../store/state";
import { generateBlockId, toast } from "@/utils/util";
import { checkImgContent } from '@/utils/utils';
import {getQueryString} from "@/utils/location";
const _tabList_ = [
  {
    id: 0,
    title: '视频帧选取'
  },
  {
    id: 1,
    title: '智能封面',
  },
  {
    id: 2,
    title: '相册选取'
  }
]
@Component({
  components: {
    VideoTab,
    Subtitles,
    ImgTrack
  }
})
@moduleStore.initVuex({
	mutationNames: moduleStore.mutationNames,
	actionNames: moduleStore.actionNames
})
export default class Cover extends Vue {
  state = new PageState();
  @Prop({default: true})
  showCanvas: boolean; // 视频帧选取时是否显示canvas
  @Prop({default: []})
  imgList: Array<any>
  @Prop({default: 0})
  canvasWidth: number
  @Prop({default: {}})
  curSpeakerAudio: any
  @Prop({default: 0})
  canvasHeight: number
  @Prop({default: ''})
  imgCoverUrl: String
  @Prop({default: {}})
  renderEle: any
  @Prop({default: {}})
  showCover: boolean
  @Prop({default: ''})
  taskId: string
  @Prop({default: ''})
  scaleRatio: string
  @Prop({default: ''})
  resolutionRatio: string
  @Prop({default: () => []})
  coverMaterialList: Array<any>
  @Prop({default: () => ''})
  articleId: any
  @Inject({from: 'triggerEditorSubtitle'})
  triggerEditorSubtitle
  show = false
  // tabList
  tabList = JSON.parse(JSON.stringify(_tabList_))
  // 当前tab
  activeTab = this.tabList[0]
  activeImg: any = {}
  contentHeight = 'calc(100vh - 370px - 32px - 56px)'
  galleryContentHeight = 'calc(100vh - 370px - 140px)'
  // 上传图片list
  uploadImageList = []
  imgPlayer: ImagePlayer
  textList = []
  _inter
  composeCoverUrl = ''
  imgInfo = {
    width: 0,
    height: 0
  }
  imgInstance
  // 生成状态
  composeStatus = 1
  composeBtnTextMap = {
    0: '生成中...',
    1: '完成',
    2: '生成失败'
  }
  trackWrapperRef = null
  curSelect:any = {
		type: 'img',
		selectIndex: -1
	}
  coverPickerHeight = '100vh'
  coverParams: any
  imgFilterList = []
  imgMap = {}
  // 是否展示智能封面
  showBrainPowerCover = false
  isApp = judgeDeviceType.isAPP
  brainImgList = [
    // {
    //   id: 0,
    //   imgUrl: 'https://tc-nj-yuan365-pub-cdn.mobvoi.com/sdxl/Wen_guangyin/img_tmp/c1c5009edb_188431f8-31f3-11ef-986e-52540049eb51.png'
    // },
    // {
    //   id: 1,
    //   imgUrl: 'https://tc-nj-yuan365-pub-cdn.mobvoi.com/sdxl/Wen_guangyin/img_tmp/c1c5009edb_188431f8-31f3-11ef-986e-52540049eb51.png'
    // },
    // {
    //   id: 2,
    //   imgUrl: 'https://tc-nj-yuan365-pub-cdn.mobvoi.com/sdxl/Wen_guangyin/img_tmp/c1c5009edb_188431f8-31f3-11ef-986e-52540049eb51.png'
    // },
    // {
    //   id: 3,
    //   imgUrl: 'https://tc-nj-yuan365-pub-cdn.mobvoi.com/sdxl/Wen_guangyin/img_tmp/c1c5009edb_188431f8-31f3-11ef-986e-52540049eb51.png'
    // },
    // {
    //   id: 4,
    //   imgUrl: 'https://tc-nj-yuan365-pub-cdn.mobvoi.com/sdxl/Wen_guangyin/img_tmp/c1c5009edb_188431f8-31f3-11ef-986e-52540049eb51.png'
    // },
    // {
    //   id: 5,
    //   imgUrl: 'https://tc-nj-yuan365-pub-cdn.mobvoi.com/sdxl/Wen_guangyin/img_tmp/c1c5009edb_188431f8-31f3-11ef-986e-52540049eb51.png'
    // },
    // {
    //   id: 6,
    //   imgUrl: 'https://tc-nj-yuan365-pub-cdn.mobvoi.com/sdxl/Wen_guangyin/img_tmp/c1c5009edb_188431f8-31f3-11ef-986e-52540049eb51.png'
    // },
    // {
    //   id: 7,
    //   imgUrl: 'https://tc-nj-yuan365-pub-cdn.mobvoi.com/sdxl/Wen_guangyin/img_tmp/c1c5009edb_188431f8-31f3-11ef-986e-52540049eb51.png'
    // },
  ]
  activeCover:any = {}
  // 生成限制次数
  totalCount = 0
  // 剩余生图次数
  leftCount = 0
  // 生成状态 0 默认 1 生成中
  generateStatus = 0
  queryTitleTimer = null
  // 当前封面
  currCoverUrl: String = ''
  // 是否滚动更新
  isScrollUpdate = true
  // 旧参数
  oldCompositeParams = {}
  isDouyin = getQueryString('platform') === 'tt';
  @Watch('imgList', {deep: true, immediate: true})
  listenImgList(val) {
    if (val.length) {
      if(!this.imgCoverUrl && this.showCanvas) this.activeImg = val[0]
      this.imgList.forEach(item => {
        const index = this.imgFilterList.findIndex(_item => item.imgUrl === _item.imgUrl)
        if (index === -1) {
          this.imgFilterList.push(item)
          // this.loadingImage()
        }
      })
    }
  }
  @Watch('showCover')
  listenShowCover(val) {
    this.show = val
    this.$nextTick(() => {
      this.initListener()

    })
    this.tabList = JSON.parse(JSON.stringify(_tabList_))
    if(this.state.isSwitch) {
      this.initUniqueId()
      this.getBrainList()
      this.getGenImgLimitCount()
    } else {
      this.tabList.splice(1, 1)
    }
    if (this.imgCoverUrl) {
      this.currCoverUrl = this.imgCoverUrl
    }
    this.changeTab(this.tabList[0])
    
  }
  @Watch('imgCoverUrl')
  listenCoverUrl(val) {
    console.log('listenCoverUrl', val)
    if(!val) return;
    this.activeImg = {
      imageId: Date.now(),
      thumbnailUrl: val,
      imgUrl: val
    }
  }
  @Watch('coverMaterialList', {deep: true})
  listenCoverMaterialList(val) {
    if (val && val.length) {
      val.forEach((item, index) => {
        let obj = {
          id: Date.now() + Math.random() + '',
          text: item.content, // 字幕内容
          fontColour: item.fontColour, // 字体颜色
          fontPercent: item.fontPercent + 1 || DEFAULTFONTSIZE[this.scaleRatio] || 8, // 新-字体大小
          alpha: item.alpha || 1, // 字体透明度
          fontStrokeColor: item.outlineColour || item.fontStrokeColor, // 字体描边颜色
          fontStrokeWidth: 1, // 字体描边宽度
          type: 1, // 操作类型 1 正常赋值 2 撤销回退重新复制
          scale: 0.1,
          fontFamily: item.fontname || '',
          initSubtitleWidth: 0,
          scaleVector2d: {
            x: item.scaleX,
            y: item.scaleY
          },
          yRatio: item.yRatio,
          xRatio: item.xRatio,
          showBorder: false
        }
        this.textList.push(obj)
      })
      const curInfo = val.find(item => item.url && item.url)
      if (curInfo) {
        this.activeImg = {
          imageId: Date.now(),
          thumbnailUrl: curInfo.url,
          imgUrl: curInfo.url
        }
      }
    }
    
  }
  created(moduleData: IinjectDatas) {
    this.state = <PageState>moduleData.state;
  }
  mounted() {
    this.$nextTick(() => {
      this.initLayout()
    })
    
    this.$bus.$on('setCoverImageBlob', this.setImageBlob)
    this.$bus.$on(this.$EventBusKey.ADD_COVER_TEXT, this.addText)
  }
  beforeDestroy() {
    this.$bus.$off('input-substitle', this.inputSubtTitle)
    this.$bus.$off(this.$EventBusKey.ADD_COVER_TEXT, this.addText)
  }
  initLayout() {
    this.$nextTick(() => {
      const playerContainer = document.getElementsByClassName('player_container')[0]
      this.contentHeight =  `calc(100vh - ${playerContainer.clientHeight}px - 32px - 130px)`
      this.galleryContentHeight =  `calc(100vh - ${playerContainer.clientHeight}px - 160px)`
      this.state.styleContentHeight = `calc(100vh - ${playerContainer.clientHeight}px - 32px - 130px + 170px)`
    })
    this.$bus.$on('input-subtitle', this.inputSubtTitle)
  }
  initListener() {
    this.trackWrapperRef = this.$refs.trackWrapperRef as HTMLElement;
    this.trackWrapperRef && this.trackWrapperRef.addEventListener('scroll', this.throttle(() => {		
      this.renderEl()
		}, 500), false)
  }
  renderEl() {
    if (!this.isScrollUpdate) return
    let trackdom = document.querySelector('.Time-track') as any;
    const scrollLeft = this.trackWrapperRef.scrollLeft
    const offsetWidth = trackdom.offsetWidth
    const curtime = scrollLeft / offsetWidth * 2;
    let imgEle = this.imgList.filter((ele) => {
      return ele.startTime >= curtime || ele.endTime > curtime
    })
    const imgInfo = imgEle[0]
    const index = this.imgFilterList.findIndex(item => item.imgUrl === imgInfo.imgUrl)
    
    // const index = this.imgList.findIndex(ele => ele.imgId === imgInfo.id)
     if (imgInfo) {
      this.activeCover = {}
      this.activeImg = {}
    }
    if(!this.showCanvas) {
      this.activeImg = {};
      this.$emit('updateRenderEle', curtime);
      return;
    }
    this.activeImg = imgInfo
    
  }
  /**
   * 清空选择
   */
  clearSelect() {
    this.activeCover = {}
    this.activeImg = {}
    this.curSelect = {}
  }
  /**
   * 加载图片
   */
  loadingImage() {
    this.imgFilterList.forEach((item, index) => {
      this.imgMap[index] = new Image()
      this.imgMap[index].src = item.imgUrl
      this.imgMap[index].onload = () => {
      }
    })
    
  }
  initUniqueId() {
    if (!this.state.articleInfo.uniqueId) {
      this.state.articleInfo.uniqueId = generateBlockId()
      this.$bus.$emit(this.$EventBusKey.UPDATE_ARTICLE_AI)
    }
  }
  /**
   * 获取生成记录
   */
  getBrainList() {
    const params = {
      page: 1,
      size: 10000,
      type: 'CONVER_IMG',
      uniqueId: this.state.articleInfo.uniqueId
    }
    this.$http('getBrainRecordList', params).then((res) => {
      if (res.code === 200) {
        const { results } = res.data
        if (results && results.length) {
          this.brainImgList = []
          results.forEach(item => {
            const imageList = item.output.imageList
            if (imageList && imageList.length) {
              imageList.forEach((url, index) => {
                this.brainImgList.push({
                  ...item,
                  _id: item.id + '_' + index,
                  imgUrl: url
                })
              })
            }
          })
        }
      }
    })
  }
  /**
   * 查询生成智能图片次数
   */
  getGenImgLimitCount() {
    this.$http('queryGenImgLimitCount', {typeEnum: 'CONVER_IMG'}).then((res) => {
      if (res.code === 200 && res.data) {
        this.totalCount = res.data.totalCount
        this.leftCount = res.data.leftCount
      }
    })
  }
  /**
   * 生图
   */
  generateBrainImg() {
    if (this.leftCount === 0) return
    this.generateImg()
  }
  /**
   * 智能生图
   */
  generateImg() {
    const articleInfo = this.state.articleInfo
    const extendVO:any = articleInfo.extendVO
    const params  ={
      articleId: articleInfo.articleId,
      uniqueId: articleInfo.uniqueId,
      text2ImgVO: {
        content: articleInfo.title,
        articleTransform: extendVO.articleTransform,
        styleCode: extendVO.styleCode,
        scaleCode: extendVO.scaleCode,
        effectCode: extendVO.effectCode
      },
      type: 'CONVER_IMG'
    }
    if (this.generateStatus === 1) return
    this.generateStatus = 1
    this.$http('generateText2Img', params).then(res => {
      if (res.code === 200 && res.data.id) {
        this.queryGenerateResult(res.data.id)
      } else {
        toast('生成智能封面失败')
        this.generateStatus = 0
      }
    }).catch(() => {
      this.generateStatus = 0
    })
  }
  queryGenerateResult(id) {
    this.$http('queryRecordStatus', {recordIds: [id]}).then(res => {
      if (res.code === 200) {
        const status = res.data[0].status
        if (status === 1) {
          this.queryTitleTimer = setTimeout(() => {
            this.clearQueryTiltTimer()
            this.queryGenerateResult(id)
          }, 3000)
        } else if(status === 2) {
          this.clearQueryTiltTimer()
          this.getBrainList()
          this.generateStatus = 0
          this.getGenImgLimitCount()
        } else {
          toast('生成智能封面失败')
          this.clearQueryTiltTimer()
          this.generateStatus = 0
          this.getGenImgLimitCount()
        }
      } else {
        toast('生成智能封面失败')
        this.clearQueryTiltTimer()
        this.generateStatus = 0
        this.getGenImgLimitCount()
      }
    }).catch(() => {
      this.generateStatus = 0
      this.getGenImgLimitCount()
    })
  }
  clearQueryTiltTimer() {
    this.queryTitleTimer && clearTimeout(this.queryTitleTimer)
    this.queryTitleTimer = null
  }
  throttle(func, delay) {
		let timerId = null;
		return function () {
			if (timerId) {
				clearTimeout(timerId);
			}
			timerId = setTimeout(func, delay);
		}
	}
  
  updateRel() {
    let trackdom = document.querySelector('.Time-track') as any;
    const scrollLeft = this.trackWrapperRef.scrollLeft
    const offsetWidth = trackdom.offsetWidth
    const curtime = scrollLeft / offsetWidth * 2;
    let imgEle = this.imgList.filter((ele) => {
        return ele.startTime >= curtime || ele.endTime > curtime
      })
    console.log('updateRel', imgEle[0])
    this.activeImg = imgEle[0]
  }
  /**
   * 选择图片
   * @param item
   * @param idnex 
   */
  trackImgClick(item, index) {
    this.clearSelect()
    this.curSelect = {
			type: 'img',
			selectIndex: index
		}
    if(!this.showCanvas) {
      this.activeImg = {};
      this.$emit('updateRenderEle', item.startTime)
      return;
    }
    this.activeImg = item
  }
  inputSubtTitle(val, index) {
    let _index = index
    if (val.index !== undefined) {
      _index = val.index
    }
    const currentTextIndex = this.textList.findIndex((item, idx) => idx === _index)
    if (currentTextIndex === -1) return
    const currentInfo = {...this.textList[currentTextIndex], ...val}
    this.textList.forEach(item => item.showBorder = false)
    if (val.showBorder) {
      this.textList[currentTextIndex].showBorder = val.showBorder
    }
    if (currentInfo.isDrag) {
      currentInfo.isInit = false
    }
    console.log('inputSubtTitle', currentInfo)
    this.textList.splice(currentTextIndex, 1, currentInfo)
  }
  showExportVideo() {
    this.$emit('show-export-video')
  }
  /**
   * 切换tab
   * @param tab
   */
  changeTab(tab) {
    if (tab.id === 1) {
      this.showBrainPowerCover = true
      return
    }
    this.activeTab = tab
  }
  changeImg(img) {
    this.activeImg = img
  }
  /**
   * 选择图片点击事件
   */
  selectFileClick() {
    (this.$refs.uploadRef as HTMLElement).click()
  }
  /**
   * 选择图片文件上传
   * @param event
   */
  selectFileImg(event) {
    console.log('selectFileImg', event.target.files[0])
    const file = event.target.files[0]
    let imgForm = new FormData()
		imgForm.append('file', file);
    (this.$refs.uploadRef as any).value = ''
		//文件上传
		let uploadUrl = 'https://tts-files.mobvoi.com/v1/file/uploadToOss'
    Axios.post(uploadUrl, imgForm, {
			headers: { 'Content-Type': 'multipart/form-data' },
			timeout: 1000 * 60 * 30 // 设置30分钟超时
		}).then(async res => {
			if (res.status != 200 || res.data.code !== 200 || !res.data.data) {
				return this.$toast({
          message: '图片上传失败'
        })
			}
      const checkRes = await checkImgContent(this, { image: res.data.data });
      if (checkRes) return;

      this.uploadImageList.push({
        imageId: Date.now(),
        thumbnailUrl: res.data.data,
        imgUrl: res.data.data
      })
      console.log('res.data.data', res.data.data)
		})
  }
  setImageBlob(bolb) {
    const file = new File([bolb], 'image.png', { type: 'image/png' });
    let imgForm = new FormData()
		imgForm.append('file', file);
		let uploadUrl = 'https://tts-files.mobvoi.com/v1/file/uploadToOss'
    Axios.post(uploadUrl, imgForm, {
			headers: { 'Content-Type': 'multipart/form-data' },
			timeout: 1000 * 60 * 30 // 设置30分钟超时
		}).then(res => {
			if (res.status != 200 || res.data.code !== 200 || !res.data.data) {
				return this.$toast({
          message: '图片获取失败'
        })
			}
      this.activeImg = {
        imageId: Date.now(),
        thumbnailUrl: res.data.data,
        imgUrl: res.data.data
      }
      this.completeBtn();
      console.log('res.data.data', res.data.data)
		})
  }

  /**
   * 删除图片
   * @param img
   * @param index 
   */
  deleteImg(img, index) {
    if (index === 0 && this.uploadImageList[0].imgUrl === this.activeImg.imgUrl) {
      this.activeImg = this.imgList[0]
      if(!this.showCanvas) {
        this.activeImg = {};
      }
    }
    this.uploadImageList.splice(index, 1)
  }
  confirmCoverPicker() {
    this.closePopup()
  }
  /**
   * 关闭弹窗
   */
  closePopup() {
    this.show = false
    this.$emit('close')
  }
  /**
   * 添加文字
   */
  addText(text?:string) {
    this.textList.push({
      id: Date.now() + Math.random() + '',
      text: text || '请输入文字', // 字幕内容
      fontColour: '#FFE001', // 字体颜色
      fontPercent: DEFAULTFONTSIZE[this.scaleRatio] || 8, // 新-字体大小
      alpha: 1, // 字体透明度
      bgColor: '', // 背景颜色
      fontStrokeColor: '#000000', // 字体描边颜色
      fontStrokeWidth: 0.01, // 字体描边宽度
      bgMode: 'none', // 背景模式
      bgAlpha: 1, // 背景透明度
      type: 1, // 操作类型 1 正常赋值 2 撤销回退重新复制
      marginV: 0.1,
      marginL: 0.5,
      scale: 0.1,
      fontFamily: 'Douyin Sans',
      initSubtitleWidth: 0,
      scaleVector2d: {
        x: 1,
        y: 1
      },
      yRatio: 0.8,
      xRatio: 0.5,
      isInit: true,
      offsetTop: 0,
      showBorder: false
    })
  }
  /**
   * 智能标题点击
   */
  brainTitleClick() {

    this.$bus.$emit(this.$EventBusKey.SHOW_STYLE_POPUP, 'brain-title')
  }
  /**
   * 修改字幕
   * @param textItem
   * @param index 
   */
  editorSubtitle(textItem, index) {
    if (!this.textList[index]) return
    textItem.index = index
    this.triggerEditorSubtitle(textItem)
  }
  changeTextInfo(x, index) {
    this.textList[index].xRatio = x
  }
  /**
   * 删除该字幕
   * @param index 
   */
  delSubtitle(index) {
    this.textList.splice(index, 1)
  }
  /**
   * 确认
   */
  completeBtn(type?: string) {
    if (type === 'brain') {
      this.confirmBrain()
    } else {
      this.confirmCommonCover()
    }
  }
  /**
   * 确认智能封面
   */
  confirmBrain() {
    if (this.textList.length <= 0) {
      if (!this.activeCover || !this.activeCover.imgUrl) {
        this.clseoBrain()
      } else {
        this.composeCoverUrl = this.activeCover.imgUrl
        this.currCoverUrl = this.activeCover.imgUrl
        this.clseoBrain()
        this.trackWrapperRefToLeft()
      }
    } else {
      if (this.activeCover.imgUrl && this.checkisComposite()) {
        this.compositeCover()
      } else {
        this.clseoBrain()
      }
      
    }
  }
  /**
   * 返回是否需要合成
   * @returns 
   */
  checkisComposite() {
    const paramList = this.getParamsList()
    const params = {
      coverUrl: this.activeImg.imgUrl,
      taskId: this.taskId,
      articleId: this.articleId,
      coverMaterialList: paramList
    }
    return JSON.stringify(this.oldCompositeParams) !== JSON.stringify(params)
  }
  /**
   * 确认普通封面
   */
  confirmCommonCover() {
    if (!this.activeImg || !this.activeImg.imgUrl) {
      // return this.$toast({
      //   message: '请选择图片'
      // })
      if(!this.showCanvas) {
        this.$emit('getRenderImageBlob')
        return;
      }
      this.closePopup()
      return
    }
    if (this.textList.length <= 0) {
      this.composeCoverUrl = this.activeImg.imgUrl
      this.$emit('complete-cover', this.composeCoverUrl)
    } else if (this.composeCoverUrl && !this.checkisComposite()) {
      this.$emit('complete-cover', this.composeCoverUrl)
    } else {
      this.compositeCover()
    }
  }
  clseoBrain() {
    this.showBrainPowerCover = false
    this.changeTab(this.tabList[0]);
  }
  /**
   * 滚动到开头
   */
  trackWrapperRefToLeft() {
    this.$nextTick(() => {
      this.trackWrapperRef.scrollLeft = 0
      this.isScrollUpdate = false
      let timer = setTimeout(() => {
        this.isScrollUpdate = true
        clearTimeout(timer)
        timer = null
      }, 1000)
    })
  }
  /**
   * 获取合成封面需要的参数
   */
  getParamsList() {
    return this.textList.map(item => {
      const scaleRatioList = (this.scaleRatio + '').split(':')
      const resolution = RESOLUTION[this.resolutionRatio];
      let playResX = 0
      let playResY = 0
      if (Number(scaleRatioList[0]) > Number(scaleRatioList[1])) {
        playResX = Number(resolution)
        playResY = Number(resolution) / (Number(scaleRatioList[0]) / Number(scaleRatioList[1]))
      } else {
        playResY =  Number(resolution)
        playResX = Number(resolution) * (Number(scaleRatioList[0]) / Number(scaleRatioList[1]))
      }
      playResX = Math.round(playResX);
      playResY = Math.round(playResY);
      
      let obj = {
        type: 'text',
        content: item.text,
        fontPercent: (item.fontPercent - 1 >= 1 ? item.fontPercent - 1 : 1) || 8,
        fontColour: item.fontColour,
        fontStrokeColor: item.fontStrokeColor,
        fontStrokeSize: 1,
        playResX,
        playResY,
        alpha: item.alpha,
        url: this.activeImg.imgUrl,
        yRatio: item.yRatio,
        xRatio: item.xRatio
      }
      if (item.fontFamily) {
        obj['fontname'] = item.fontFamily
      }
      return obj
    })
  }
  /**
   * 合成封面
   */
  compositeCover() {
    let paramList = this.getParamsList()
    const params = {
      coverUrl: this.activeImg.imgUrl,
      taskId: this.taskId,
      articleId: this.articleId,
      coverMaterialList: paramList
    }
    this.oldCompositeParams = JSON.parse(JSON.stringify(params))
    if (this.composeStatus === 0) {
      this.$toast({
        message: '正在合成中...'
      })
      return
    }
    paramList = paramList.filter(item => item.content.trim())
      this.composeStatus = 0
      this.coverParams = paramList
      this.$http('composeCover', params).then(res => {
        if (res.code === 200) {
          const coverTaskId = res.data.coverTaskId
          this.checkComposeImg(coverTaskId)
          this._inter = setInterval(() => {
            this.checkComposeImg(coverTaskId)
          }, 2000)
        } else {
          this.composeStatus = 1
        }
      })
  }
  /**
   * 查询合成图片结果
   */
  checkComposeImg(coverTaskId) {
    this.$http('queryComposeResult', {coverTaskId}).then(res => {
      if (res.code === 200) {
        if (res.data.composeCoverUrl && res.data.status === 1) {
          clearInterval(this._inter)
          this._inter = null
          this.composeCoverUrl = res.data.composeCoverUrl
          this.composeStatus = 1
          console.log('合成完成', this.coverParams)
          if (this.showBrainPowerCover) {
            this.currCoverUrl = res.data.composeCoverUrl
            this.clseoBrain()
            this.trackWrapperRefToLeft()
          } else {
            this.$emit('complete-cover', this.composeCoverUrl, this.coverParams)
            this.textList = []
          }
        }
        if (res.data.status === 2) {
          this.composeStatus = 1
          this.$toast({
            message: '合成失败'
          })
          clearInterval(this._inter)
          this._inter = null
          if (this.showBrainPowerCover) {
            this.showBrainPowerCover = false
            this.changeTab(this.tabList[0])
          } else {
            this.$emit('complete-cover', this.activeImg.imgUrl)
            this.textList = []
          }
        }
      }
    })
  }
  /**
   * 选择上传图片
   * @param imgInfo
   */
  selectUploadImg(imgInfo) {
    this.clearSelect()
    this.changeImg(imgInfo)
  }
  /**
   * 选择封面图
   * @param imgInfo
   */
  selectBrainCover(imgInfo) {
    this.clearSelect()
    this.activeCover = imgInfo
    const img = {
      imageId: Date.now(),
      thumbnailUrl: imgInfo.imgUrl,
      imgUrl: imgInfo.imgUrl
    }
    this.changeImg(img)
  }
  previewImg(imgInfo) {
    console.log('previewImg', imgInfo)
    this.$navigateTo({
      url: `/baohuo-package/pages/picture-preview/picture-preview?imgUrl=${encodeURIComponent(imgInfo.imgUrl)}&scaleRatio=${this.scaleRatio}`,
    })
  }
}